module.exports = __webpack_public_path__ + "static/media/challenge-artwork.04d16064.png";